import { render, staticRenderFns } from "./MainEmailComponent.vue?vue&type=template&id=3d490eac"
import script from "./MainEmailComponent.vue?vue&type=script&lang=js"
export * from "./MainEmailComponent.vue?vue&type=script&lang=js"
import style0 from "./MainEmailComponent.vue?vue&type=style&index=0&id=3d490eac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports